import type {GetTeams_teams as Team} from 'nutshell-graphql-types';

import type {MentionConfig} from './rich-textarea';

import {getEntities} from './mentions-utils';

export function getMentionsConfig(): MentionConfig {
    return {
        enabled: true,
        getMentions: (searchTerm: string, teams?: Team[] | null) => {
            return getEntities(searchTerm, teams).then((response) => {
                return {matches: response};
            });
        },
    };
}
